import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';

export class PartnerProfessionService {
   async getPartnerProfessions() {
      return await http.get(`/partner-professions`, cacheFirstConfig).then((response) => response.data);
   }
}
